import { OptionType } from "../../shared/components/BaseAsyncPaginate";
import { getPaginatedByNameEndUsers } from "pages/admin-app/end-user/services/end-user-service";
import {
  GetEndUsersResponse,
  EndUser,
} from "pages/admin-app/end-user/models/response/get-end-users-response";
import { createLoadOptions } from "../../service/createLoadOptions";

export interface EndUserOption extends OptionType {
  data: EndUser;
}

const fetchEndUsers = async (
  page: number,
  perPage: number,
  searchQuery?: string
): Promise<GetEndUsersResponse> => {
  return getPaginatedByNameEndUsers({ page, perPage, searchQuery });
};

export const endUserMapper = (eu: EndUser): EndUserOption => {
  return {
    value: eu.id,
    label: `${eu.name}, ${eu.city}`,
    data: eu,
  };
};

export const loadEndUsers = createLoadOptions(fetchEndUsers, endUserMapper);
